<app-navbar></app-navbar>
<div class="dashboard">

  <button class="back-button" (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <h2 class="header">Pricing Related Attributes Insights</h2>

  <div class="dashboard-grid">

    <div class="row1">
      <!-- First Row: Main 2 cards and Parameters -->
      <div class="main-metrics">
        <mat-card class="dashboard-card">
          <div class="card-content">
            <h3>Average Revenue</h3>
            <h1>1550.65</h1>
            <span class="positive">+3.5%</span>
          </div>
          <div class="chart-container">
            <ngx-charts-bar-vertical [results]="barChartData"></ngx-charts-bar-vertical>
          </div>
        </mat-card>

        <mat-card class="dashboard-card">
          <div class="card-content">
            <h3>Total DBUNetSales</h3>
            <h1>26M </h1>
            <span class="positive">+3.5%</span>
          </div>
          <div class="chart-container">
            <ngx-charts-pie-chart [results]="pieChartData" [view]="[150, 300]"></ngx-charts-pie-chart>
          </div>
        </mat-card>

        <!-- Second Row: Market Segments & Normal Distribution -->
        <mat-card class="small-card">
          <div class="market-segment">
            <h2>Market Segments</h2>
            <mat-form-field appearance="outline">
              <mat-label>Select Market Segment</mat-label>
              <mat-select [(value)]="selectedSegment">
                <mat-option *ngFor="let segment of marketSegments" [value]="segment">
                  {{ segment }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>


          <!-- Vertical Bar Chart -->
          <div class="big-chart-container">
            <ngx-charts-bar-vertical
              [view]="view"
              [results]="productData"
              [gradient]="barChartConfig.gradient"
              [xAxis]="barChartConfig.showXAxis"
              [yAxis]="barChartConfig.showYAxis"
              [legend]="barChartConfig.showLegend"
              [showXAxisLabel]="barChartConfig.showXAxisLabel"
              [showYAxisLabel]="barChartConfig.showYAxisLabel"
              [xAxisLabel]="barChartConfig.xAxisLabel"
              [yAxisLabel]="barChartConfig.yAxisLabel"
              [roundEdges]="true">
            </ngx-charts-bar-vertical>
          </div>
        </mat-card>

        <mat-card class="small-card">
          <h2>Distribution</h2>
          <div id="distributionChart" style="width: 100%; height: 400px;"></div>
        </mat-card>

      </div>



      <!-- Parameters Card Stays on the Right -->
      <mat-card class="dashboard-card3">
        <h2>Parameters</h2>
        <div *ngFor="let param of parameters">
          <p>{{ param.label }}</p>
          <div class="param">
            <mat-progress-bar
              mode="determinate"
              [value]="param.value"
              [color]="param.color">
            </mat-progress-bar>
            <div class="content">
              <p class="positive">+{{ param.growth }}%</p>
              <p>Session: {{ param.session }}</p>
            </div>
          </div>
        </div>
      </mat-card>

    </div>
  </div>


  <!-- Analysis Section -->
  <div class="row3">
    <mat-card class="insights">
      <img src="assets\🦆 icon _right right_.png" alt="img">
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit...
        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
        Lorem ipsum dolor sit amet, consectetur adipiscing elit
        Lorem ipsum dolor sit amet, consectetur adipiscing elit
      </p>
    </mat-card>
    <div class="image-container">
      <img src="assets/image bg.png" alt="img">
    </div>

  </div>


  <div class="analysis-section">
    <h1>Analysis<span><img src="assets\🦆 icon _right right_.png" alt="img"></span></h1>

    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit...</p>
  </div>
</div>
